<div class="welcome-page">
    <div class="base-info">
        <div class="content-container">
            <div class="content">
                <h2>Welcome to the McGriff Portal for the Amazon Asset Insurance Program</h2>
                <p>1. Register to create your account</p>
                <p>2. Download ID Cards</p>
                <p>3. Manage Your Drivers</p>
            </div>
        </div>
    </div>
    <div class="register-info">
        <form (ngSubmit)="onSubmit()" #form="ngForm">
            <img src="../../../assets/freight-logo.svg" alt="freight-logo">
            <div class="form-group">
                <input class="form-input" name="email" type="email" id="welcome-email"
                    [(ngModel)]="email" placeholder="Email" #emailInput="ngModel"
                    required/>
                <label for="welcome-email" class="form_label">Email</label>
                <div *ngIf="form.submitted && emailInput.invalid"
                    class="alert alert-danger">
                    <span>Please enter Email</span>
                </div>
            </div>
            <div class="form-group">
                <input class="form-input" name="newPass" type="password" id="welcome-pass"
                    [(ngModel)]="password" placeholder="Create Password" #passInput="ngModel"
                    required/>
                <label for="welcome-pass" class="form_label">Create Password</label>
                <div *ngIf="form.submitted && passInput.invalid"
                    class="alert alert-danger">
                    <span>Please enter Password</span>
                </div>
            </div>
            <div class="actions">
                <button type="submit" class="primary-button" id="registerBtn">
                    Register
                </button>
                <div>
                    <span>I already registered,</span>
                    <a [routerLink]="['']">Sign In</a>
                </div>
            </div>
        </form>
        <div class="info">
            <p>Any questions? Call us <a href="tel:+18448186243">844-818-6243</a></p>
        </div>
    </div>
</div>
